import type { ValuesOf } from '@do/models';

export const LabelColor = {
  Grey: 'grey',
  Slate: 'slate',
  LightGreen: 'light_green',
  Emerald: 'emerald',
  LightBlue: 'light_blue',
  Blue: 'blue',
  Red: 'red',
  Amber: 'amber',
  Orange: 'orange',
  Dark: 'dark',
  Fuchsia: 'fuchsia',
  Teal: 'teal',
  Indigo: 'indigo',
  Purple: 'purple',
  Cyan: 'cyan',
} as const;
export type LabelColor = ValuesOf<typeof LabelColor>;
